import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'
import DataUtils from '@/utils/DataUtils'

function searchInput (input, contentType) {
  return DataUtils.mergeObjects(input, {
    cons: { content_type: contentType }
  })
}

const module = {
  state: {
    contentSectionContentType: null,
    programs: [],
    courses: [],
    seminars: [],
    events: [],
    programsOptions: {},
    coursesOptions: {},
    seminarsOptions: {},
    eventsOptions: {}
  },
  getters: {
    getContentSectionContentType (state) {
      return state.contentSectionContentType
    },
    getPrograms (state) {
      return state.programs
    },
    getCourses (state) {
      return state.courses
    },
    getSeminars (state) {
      return state.seminars
    },
    getEvents (state) {
      return state.events
    },
    getProgramsOptions (state) {
      return state.programsOptions
    },
    getCoursesOptions (state) {
      return state.coursesOptions
    },
    getSeminarsOptions (state) {
      return state.seminarsOptions
    },
    getEventsOptions (state) {
      return state.eventsOptions
    }
  },
  mutations: {
    SET_CONTENT_SECTION_CONTENT_TYPE (state, payload) {
      state.contentSectionContentType = payload
    },
    SET_PROGRAMS (state, payload) {
      state.programs = payload
    },
    SET_COURSES (state, payload) {
      state.courses = payload
    },
    SET_SEMINARS (state, payload) {
      state.seminars = payload
    },
    SET_EVENTS (state, payload) {
      state.events = payload
    },
    SET_PROGRAMS_OPTIONS (state, payload) {
      state.programsOptions = payload
    },
    SET_COURSES_OPTIONS (state, payload) {
      state.coursesOptions = payload
    },
    SET_SEMINARS_OPTIONS (state, payload) {
      state.seminarsOptions = payload
    },
    SET_EVENTS_OPTIONS (state, payload) {
      state.eventsOptions = payload
    }
  },
  actions: {
    search: ({ state, commit }, input) => {
      return ApiUtils.postData({
        data: [
          { api: 'L0101ContentService.searchContent', input: searchInput(input, 'PROGRAM') },
          { api: 'L0101ContentService.searchContent', input: searchInput(input, 'COURSE') },
          { api: 'L0101ContentService.searchContent', input: searchInput(input, 'SEMINAR') },
          { api: 'L0101ContentService.searchContent', input: searchInput(input, 'EVENT') }
        ]
      }).then(data => {
        commit('SET_PROGRAMS', data[0].output.data)
        commit('SET_PROGRAMS_OPTIONS', data[0].output)

        commit('SET_COURSES', data[1].output.data)
        commit('SET_COURSES_OPTIONS', data[1].output)

        commit('SET_SEMINARS', data[2].output.data)
        commit('SET_SEMINARS_OPTIONS', data[2].output)

        commit('SET_EVENTS', data[3].output.data)
        commit('SET_EVENTS_OPTIONS', data[3].output)
      })
    },

    read: ({ commit }, payload) => {
      return ApiUtils.postData({
        data: [
          { api: 'L0101ContentService.readContent', input: payload }
        ]
      }).then(data => {
        commit('SET_ROW', data[0].output)
        return data
      })
    },

    edit: ({ state }) => {
      return ApiUtils.postData({
        data: [{ api: 'L0101ContentService.editContent', input: state.row }]
      })
    },

    reviewComplete: (ctx, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'L0101ContentService.reviewComplete', input: payload }]
      })
    },

    add: (ctx, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'L0101ContentService.addContent', input: payload }]
      })
    },

    delete: (ctx, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'L0101ContentService.deleteContent', input: payload }]
      })
    },
    submitForReview: (ctx, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'L0101ContentService.submitForReview', input: payload }]
      })
    },

    getContentSectionContentTypeList: ({ commit }) => {
      return ApiUtils.postData({
        data: [{ api: 'L0601ContentSectionContentService.getTypeList' }]
      }).then(data => {
        commit('SET_CONTENT_SECTION_CONTENT_TYPE', data[0].output)
      })
    },

    async doSeachCalendar (_, payload) {
      const data = await ApiUtils.postData({ data: [{ api: 'L0101ContentService.doSearchCalendar', input: payload }] })
      return data[0].output
    },

    // Submit survey form for class attendance or completion
    submitSurveyForm: async (_, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'L0101ContentService.submitSurvey', input: payload }]
      }).then(data => {
        return data[0].output
      })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
